import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LogOut, Settings, LogIn } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import FeedbackButton from '../FeedbackButton';
import NotificationBell from '../notifications/NotificationBell';
import { supabase } from '../../lib/supabase';
import { useNotificationStore } from '../../stores/notificationStore';

export default function Navigation() {
  const { user, signOut } = useAuth();
  const { fetchNotifications, subscribeToNotifications, unsubscribeFromNotifications } = useNotificationStore();

  useEffect(() => {
    if (user) {
      // Initial fetch of notifications
      fetchNotifications();
      
      // Subscribe to real-time updates
      subscribeToNotifications(user.id);

      // Cleanup subscription on unmount
      return () => {
        unsubscribeFromNotifications();
      };
    }
  }, [user, fetchNotifications, subscribeToNotifications, unsubscribeFromNotifications]);

  const handleSignOut = async () => {
    try {
      // Clear any stored auth data first
      const domain = supabase.auth.storageKey.split('-')[0];
      localStorage.removeItem(`${domain}-auth-token`);
      
      // Then sign out
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/image.png" alt="Calenlist" className="h-8 w-8" />
              <span className="ml-2 text-xl font-semibold text-gray-900">Calenlist</span>
            </Link>
          </div>
          <div className="flex items-center">
            {user ? (
              <div className="flex items-center">
                <div className="flex items-center gap-2 mr-4">
                  <FeedbackButton />
                  <NotificationBell />
                </div>
                <div className="flex items-center gap-4">
                  <Link
                    to="/profile/settings"
                    className="text-gray-600 hover:text-gray-900"
                    title="Profile Settings"
                  >
                    <Settings className="h-5 w-5" />
                  </Link>
                  <button
                    onClick={handleSignOut}
                    className="text-gray-600 hover:text-gray-900"
                    title="Sign Out"
                  >
                    <LogOut className="h-5 w-5" />
                  </button>
                </div>
              </div>
            ) : (
              <Link
                to="/login"
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
              >
                <LogIn className="h-4 w-4 mr-2" />
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}